import { ArrowUpRight } from 'lucide-react'

import { DonationPanel } from '@/components/DonationPanel'
import { InnerHero } from '@/components/InnerHero'
import { Reveal } from '@/components/Reveal'
import { waysToHelp } from '@/data/site'

export function HelpPage() {
  return (
    <>
      <InnerHero
        eyebrow="Tu ayuda se convierte en acción"
        title="Hay muchas formas de estar"
        description="Una donación importa. Una recomendación importa. Compartir la historia también. El movimiento crece cuando cada persona aporta desde lo que puede."
      />

      <section className="section-space pt-0" aria-labelledby="ways-title">
        <div className="container-wide">
          <h2 className="sr-only" id="ways-title">
            Formas de ayudar
          </h2>
          <div className="resource-grid">
            {waysToHelp.map((way, index) => {
              const Icon = way.icon

              return (
                <Reveal delay={index * 0.08} key={way.title}>
                  <a className="resource-card group" href={way.href}>
                    <div className="flex items-start justify-between">
                      <span className="resource-card-icon">
                        <Icon aria-hidden="true" size={27} strokeWidth={1.7} />
                      </span>
                      <ArrowUpRight
                        aria-hidden="true"
                        className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                        size={27}
                      />
                    </div>
                    <div>
                      <p className="mb-3 text-xs font-extrabold tracking-[0.12em] uppercase opacity-60">
                        {way.cta}
                      </p>
                      <h3>{way.title}</h3>
                      <p>{way.description}</p>
                    </div>
                  </a>
                </Reveal>
              )
            })}
          </div>
        </div>
      </section>

      <section className="story-preview section-space" aria-labelledby="help-story-title">
        <div className="container-wide story-grid">
          <Reveal>
            <img
              className="aspect-[4/5] w-full rounded-[3rem] object-cover shadow-lift"
              src="/assets/images/noa-mirada.webp"
              alt="Noa mirando hacia arriba en un jardín"
              width="1076"
              height="1308"
              loading="lazy"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <p className="eyebrow !text-apricot before:!bg-apricot">El valor de estar</p>
            <h2 className="section-title" id="help-story-title">
              La ayuda constante cambia lo que una familia puede imaginar.
            </h2>
            <p className="lede mt-7 !text-white/70">
              Los tratamientos son intensivos, el equipo es costoso y el cuidado no se
              detiene. Una comunidad estable permite planear con más calma y sostener
              los avances.
            </p>
            <a
              className="button button-primary mt-8"
              href="/los-tios-chidos/"
            >
              Conoce a Los Tíos Chidos
              <ArrowUpRight aria-hidden="true" size={17} />
            </a>
          </Reveal>
        </div>
      </section>

      <DonationPanel />
    </>
  )
}
